
import React from "react";
import { Config } from "../App";

interface ConfigInput {
    config: Config
    updateConfig: React.Dispatch<React.SetStateAction<Config>>
}

export default function Settings(input: ConfigInput) {

    function onChangeWidth(event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>) {
        input.updateConfig({
            ...input.config,
            glyphWidth: Number.parseFloat(event.currentTarget.value),
            glyphHeight: Math.round((73 / 38) * Number.parseFloat(event.currentTarget.value))
        })
    } 
    function onChangeHeight(event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>) {
        input.updateConfig({
            ...input.config,
            glyphWidth: Math.round((38 / 73) * Number.parseFloat(event.currentTarget.value)),
            glyphHeight: Number.parseFloat(event.currentTarget.value),
        })
    } 
    function onChangeColor(event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>) {
        input.updateConfig({
            ...input.config,
            color: event.currentTarget.value,
        })
    }
    function onChangeBgColor(event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>) {
        input.updateConfig({
            ...input.config,
            backgroundColor: event.currentTarget.value,
        })
    }
    function onChangeStrokeSize(event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>) {
        input.updateConfig({
            ...input.config,
            strokeSize: event.currentTarget.value
        })
    }

    return <div>
        <div>
            <label htmlFor="glyphwidth">Glyph Size </label>
            <input type="number" name="glyphwidth" id="glyphwidth" size={10} value={input.config.glyphWidth} onChange={onChangeWidth} /> x
            <input type="number" name="glyphheight" id="glyphheight" size={10} value={input.config.glyphHeight} onChange={onChangeHeight} /> px
        </div>
        <div>
            <label htmlFor="color">Glyph color </label>
            <input type="color" name="color" id="color" onChange={onChangeColor} />
        </div>
        <div>
            <label htmlFor="bgcolor">Background color </label>
            <input type="color" name="bgcolor" id="bgcolor" onChange={onChangeBgColor} />
        </div>
        <div>
            <label htmlFor="strokesize">Font weight</label>
            <input type="text" name="strokesize" id="strokesize" onChange={onChangeStrokeSize} placeholder={input.config.strokeSize} />
        </div>

    </div>

}